import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Popover } from "@mui/material"
import classNames from "classnames"
// import { HexColorPicker } from "react-colorful" // TODO

import { colors } from "@/components/colors"
import Icon from "@/components/icon/Icon"

import "./colorPicker.scss"

// TODO
const COLOR_PALETTE_TYPE = ["500", "700", "900"] as const
const COLOR_PALETTE_TOP_NAME: Array<keyof typeof colors> = [
  "sky",
  "blue",
  "purple",
  "pink",
] as const
const COLOR_PALETTE_BOTTOM_NAME: Array<keyof typeof colors | keyof typeof colors> = [
  "red",
  "yellow",
  "lime",
  "green",
] as const

export default function ColorPicker({
  color,
  setColor,
  hideLabel,
}: {
  color: string
  setColor: (color: string) => void
  hideLabel?: boolean
}) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  const renderColorChip = (name: keyof typeof colors) =>
    COLOR_PALETTE_TYPE.map((type) => {
      const colorValue = (colors[name as keyof typeof colors] as Record<string, string>)?.[type]

      return (
        <div
          key={type}
          className="ColorChipCont"
          onClick={() => {
            setColor(colorValue)
            setOpen(false)
          }}>
          <div
            className={"color-chip-card"}
            style={{
              backgroundColor: colorValue,
            }}
          />
          <>
            <span
              className={classNames("selected-color-overlay", {
                "selected-color": color === colorValue,
              })}></span>
            <Icon
              type="check"
              width={32}
              height={32}
              color={colors.neutral.white}
              className={classNames("selected-color-overlay-icon", {
                "selected-color": color === colorValue,
              })}
            />
          </>
        </div>
      )
    })

  return (
    <>
      <div className="ColorPickerCont">
        {!hideLabel && <p>{t("color")}</p>}
        <div
          className="color-picker-card"
          style={{
            backgroundColor: color,
          }}
          onClick={() => setOpen(!open)}
          ref={anchorRef}
        />
      </div>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        <div className="ColorPaletteCont">
          <span onClick={() => setOpen(false)}>
            <Icon type="close" size={20} color={colors.neutral.grey[400]} />
          </span>
          <div className="ColorPaletteTopCont">
            {COLOR_PALETTE_TOP_NAME.map((name) => (
              <div key={name} className="color-palette-row">
                {renderColorChip(name)}
              </div>
            ))}
          </div>
          <div className="ColorPaletteBottomCont">
            {COLOR_PALETTE_BOTTOM_NAME.map((name) => (
              <div key={name} className="color-palette-row">
                {renderColorChip(name)}
              </div>
            ))}
          </div>
        </div>
        {/* TODO 컬러팔레트 테스트 */}
        {/* <HexColorPicker color={color} onChange={setColor} /> */}
      </Popover>
    </>
  )
}
